import { createDashboardReduxModule } from 'utils/reduxDashboardModuleCreator'

export const spamWidgetRedux = createDashboardReduxModule({
  name: 'SPAM_WIDGET',
  path: 'dashboard/home/spamWidget',
})
